export enum TicketTierStatus {
    visible         = 0,
    promoterOnly    = 1,
    linkOnly        = 2,
    code            = 3,
    draft           = 4,
    deleted         = 5
}
